<template>
    <img
        src="./bell.svg"
        :class="{
            'bell-image': true,
            'follow-btn': true,
            following:
                productId != null && followingProductIds?.includes(productId),
        }"
        :alt="labels.frontendProductpage.subscription.sub"
        width="21"
        height="20"
        @click.stop.prevent="toggleFollow()"
    />
</template>

<style scoped lang="scss">
@import "common.css.src/mixins.scss";

.follow-btn {
    border-radius: 100px;
    background-color: #f6f2e6;
    transition: background-color cubic-bezier(0, 1, 0.4, 1) 1s;
    border: 2px solid #272727;
    border-radius: 100px;
    padding: 5px;
    aspect-ratio: 1/1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    transition: transform cubic-bezier(0, 1, 0.4, 1) 1s;

    @include when-desktop() {
        height: 20px;
        padding: 8px;
    }
    &.following {
        background-color: #c0d597;
        transform: rotate(30deg);
    }
}
</style>

<script setup lang="ts">
import { getFollowedProductIds } from "../../followed-products";
//import { toggleFollowProduct } from ".";
import { loginPopup } from "../../../../../../legacy/loginPopup";
import labels from "../../../../shared/labels";
import axios from "axios";

const props = defineProps({
    productId: {
        type: Number,
        required: true,
    },
});

const followingProductIds = getFollowedProductIds();

async function toggleFollowProduct(productId: number) {
    const response = await axios.post<{
        Subscribed: 0 | 1;
        Success: 0 | 1;
    }>(`/auctionProduct/ToggleSubscribeProduct/${productId}`);
    if (response.data.Success !== 1) {
        throw new Error("Failed");
    }
    return response.data.Subscribed == 1;
}

async function toggleFollow() {
    if (window.isAuthenticated() !== true) {
        loginPopup();
        return;
    }
    if (props.productId == null) throw new Error("no id");
    const following = await toggleFollowProduct(props.productId);

    if (following) {
        if (
            followingProductIds.value != null &&
            followingProductIds.value.includes(props.productId) == false
        )
            followingProductIds.value.push(props.productId);
    } else {
        if (followingProductIds.value?.includes(props.productId) == true)
            followingProductIds.value.splice(
                followingProductIds.value.indexOf(props.productId),
                1
            );
    }
}
</script>
